import { FC } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import Button from 'components/parts/button/button'
import WidthLimiter from 'containers/width-limiter/width-limiter'
import usePCWindow from 'hooks/usePCWindow'

import { STATIC_URL } from 'constants/data'
import { ScreenSize } from 'constants/media-constanst'

import styles from './intro-header.module.scss'

interface IIntroHeader {
  isMobile: boolean
  showRegistrationForm: () => void
}

const points = [
  'Обучающие материалы на основе доказательной медицины',
  'Обмен практическим опыт с врачебным сообществом',
]

const iconData = {
  src: `${STATIC_URL}/icons/icon_tick_blue.png`,
  width: 22,
  height: 22,
  alt: 'arrow',
}

const doctorImg = {
  src: `${STATIC_URL}/intro-alt/necessary/header-doctor.png`,
  width: 500,
  height: 606,
  alt: 'Doctor',
}

const doctorImgWebP = {
  src: `${STATIC_URL}/intro-alt/necessary/header-doctor.webp`,
  width: 500,
  height: 606,
  alt: 'Doctor',
}

const IntroHeader: FC<IIntroHeader> = ({ showRegistrationForm }) => {
  const isDesktop = usePCWindow(ScreenSize.big)

  return (
    <WidthLimiter noTopPadding noBottomPadding>
      <section className={styles.sectionWrapper}>
        <div className={styles.helper}>
          <h1 className={styles.title}>
            <span className={styles.colorWord}>Medpoint</span>
          </h1>

          <h1 className={styles.subtitle}>Сообщество врачей для профессионального развития</h1>
          <div className={styles.points}>
            {points.map((item, index) => {
              return (
                <div className={styles.point} key={index}>
                  <Image {...iconData} /> {item}
                </div>
              )
            })}
          </div>
          <Button modificator={styles.btnMod} onClick={showRegistrationForm}>
            Присоединиться
          </Button>
        </div>
        <div className={styles.plashka}>
          <div className={clsx(styles.helper, styles.infohelper)}>
            <div className={styles.info}>
              <div className={styles.infoTitle}>70 000+</div>
              <div className={styles.infosub}>Врачей развиваются вместе&nbsp;с&nbsp;Medpoint</div>
            </div>
            <div className={clsx(styles.info, styles.infoSecond)}>
              <div className={styles.infoTitle}>500+</div>
              <div className={styles.infosub}>Экспертов делятся своим&nbsp;опытом</div>
            </div>
            <div className={styles.infoLast}>
              <div className={styles.infoTitle}>1 000+</div>
              <div className={styles.infosub}>Прикладных материалов</div>
            </div>
          </div>
        </div>
        {isDesktop && (
          <picture className={styles.doctorWrap}>
            <div className={styles.gradDoctor} />
            <source srcSet={doctorImgWebP.src} width={500} height={600} type="image/webp" />
            <Image className={styles.doctor} {...doctorImg} />
          </picture>
        )}
        <div className={styles.circle} />
      </section>
    </WidthLimiter>
  )
}

export default IntroHeader
